export const ADD_STATE = 'ADD_STATE'
export const CLEAR_MODELS = 'CLEAR_MODELS'
export const PUT_CDS = 'PUT_CDS'
export const PUT_DMAS_BY_CD = 'PUT_DMAS_BY_CD'
export const PUT_DMAS_BY_STATE = 'PUT_DMAS_BY_STATE'
export const PUT_STATES = 'PUT_STATES'
export const PUT_AGGREGATE_MODELS = 'PUT_AGGREGATE_MODELS'
export const PUT_ELECTIONS = 'PUT_ELECTIONS'
export const PUT_ELECTION_MODELS = 'PUT_ELECTION_MODELS'
export const PUT_HOUSE_LANDING_MODELS = 'PUT_HOUSE_LANDING_MODELS'
export const PUT_SENATE_LANDING_MODELS = 'PUT_SENATE_LANDING_MODELS'
export const PUT_PAGES = 'PUT_PAGES'
export const PUT_HOUSE_MAP_MODEL = 'PUT_HOUSE_MAP_MODEL'
export const PUT_SENATE_MAP_MODEL = 'PUT_SENATE_MAP_MODEL'
export const SAVE_SESSION = 'SAVE_SESSION'
export const SET_DATES = 'SET_DATES'
export const SET_MAIN_DATES = 'SET_MAIN_DATES'
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE'
export const SET_HOUSE_DATE = 'SET_HOUSE_DATE'
export const SET_SENATE_DATE = 'SET_SENATE_DATE'
export const SET_CURRENT_STATE = 'SET_CURRENT_STATE'
export const SET_SCREEN_WIDTH = 'SET_SCREEN_WIDTH'
export const SET_MOBILE = 'SET_MOBILE'
export const SET_MOBILE_PHONE = 'SET_MOBILE_PHONE'
export const SET_MODE = 'SET_MODE'
export const SET_CHAMBER = 'SET_CHAMBER'
export const TOGGLE_TIMELINE = 'TOGGLE_TIMELINE'
export const TOGGLE_SEARCH = 'TOGGLE_SEARCH'
export const TOGGLE_CLOSED = 'TOGGLE_CLOSED'
export const TOGGLE_MENU = 'TOGGLE_MOBILE_MENU'



// WEBPACK FOOTER //
// ./src/modules/mutation-types.js